import * as React from 'react'

function SvgInteriorIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M25.65 17.976a18.892 18.892 0 0 0-11.3 0 6.003 6.003 0 0 1 11.3 0Zm-3.24 6.803a4 4 0 0 0 2.295-2.183l.665.083a6.026 6.026 0 0 1-3.054 2.858l.094-.758Zm-7.115-2.183a4 4 0 0 0 2.295 2.183l.094.758a6.026 6.026 0 0 1-3.054-2.858l.665-.083ZM20 10c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10Z"
        stroke="#000"
        strokeWidth={2}
      />
    </svg>
  )
}

export default SvgInteriorIcon
